export default __webpack_public_path__ + "assets/es.dec6ea19.svg";